export function SavedBadge() {
  return (
    <div className="saved-badge-wrapper">
      <div className="saved-badge">
        <svg className="saved-badge-icon" viewBox="0 0 54 54">
          <circle className="saved-badge-icon__circle" cx="26" cy="26" r="25" />
          <path className="saved-badge-icon__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
        </svg>
        <div className="saved-badge-text">Saved</div>
      </div>
    </div>
  )
}
